import { createIcon } from "@chakra-ui/react";

export const Program = createIcon({
  displayName: "Program",
  viewBox: "0 0 24 24",
  d: "M2.4 5.001h16.803c.33 0 .6.27.6.6v3.436l.248-.247a2.698 2.698 0 0 1 1.552-.77V5.603c0-1.324-1.076-2.4-2.4-2.4H2.4a2.403 2.403 0 0 0-2.4 2.4v9.601c0 1.324 1.076 2.4 2.4 2.4h9.996l.225-.896c.082-.33.232-.637.442-.904H2.4c-.33 0-.6-.27-.6-.6V5.602c0-.33.27-.6.6-.6zm2.1 6.001c-.498 0-.9.402-.9.9 0 .5.402.9.9.9h7.802c.499 0 .9-.4.9-.9 0-.498-.401-.9-.9-.9H4.5zm-.9-2.7c0 .499.402.9.9.9h11.402c.5 0 .9-.401.9-.9s-.4-.9-.9-.9H4.502c-.5 0-.9.401-.9.9zm19.421 1.339a1.503 1.503 0 0 0-2.123 0l-1.102 1.103 2.663 2.662 1.102-1.102a1.503 1.503 0 0 0 0-2.123l-.54-.54zm-8.923 6.8a1.187 1.187 0 0 0-.315.559l-.562 2.254a.594.594 0 0 0 .157.57c.15.15.364.21.57.157l2.255-.562c.21-.053.405-.162.558-.315l4.846-4.85-2.663-2.663-4.845 4.85z",
  defaultProps: {
    "aria-label": "A pencil and note paper icon"
  }
});

export default Program;
